var ReasonCodeCollection = require('./collection');


module.exports = ReasonCodeCollection.extend({

     // Not for displaying available in order ... this guarantees uniqueness in floating code redactions
    comparator: function(rc) {
        return rc.get('code').toLowerCase();
    },


    // If want to wrap text use '\n' as delimiter
    // note: already sorted via the comparator
    getCodesAsString: function( delimeter ) {
        return this.pluck('code').join( delimeter ? delimeter : '' );
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/reasonCodes/shapeReasonCodes.js
 ** module id = 257
 ** module chunks = 0
 **/